import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import Home from '../containers/Home'
import Profile from '../containers/Profile'
import Forum from '../containers/Forum'
import ForumTopic from '../containers/Forum/Topic'
import Login from '../containers/Login'
import PrivateRoute from './PrivateRoute'
import Course from '../containers/Course'
import NotFound from '../containers/NotFound'
import Exams from '../containers/Exams'
import ExamInfo from '../components/examsGeneralComponents/ExamInfo'
import SimulatedInfo from '../components/examsGeneralComponents/SimulatedInfo'
import CustomExamInfo from '../components/examsGeneralComponents/CustomExamInfo'
import ExamFeedbackStructure from '../containers/ExamFeedbackStructure'
import CoursesCertified from '../containers/CoursesCertified'

const BaseRoutes = () => {
  return (
    <Switch>
      <Route exact path="/login" component={Login} />
      <PrivateRoute exact path="/meu-perfil" component={Profile} />
      <PrivateRoute path="/curso/:id" component={Course} />
      <PrivateRoute path="/atividades" component={Exams} />
      <PrivateRoute path="/resultados/:id" component={ExamFeedbackStructure} />
      <PrivateRoute path="/prova/:id" component={ExamInfo} />
      <PrivateRoute path="/simulado/:id" component={SimulatedInfo} />
      <PrivateRoute path="/prova_personalizada/:id" component={CustomExamInfo} />
      <PrivateRoute path="/forum/:cursoId/:topicoId" component={ForumTopic} />
      <PrivateRoute path="/forum/:cursoId" component={Forum} />
      <PrivateRoute exact path="/" component={Home} />
      <PrivateRoute exact path="/certificados" component={CoursesCertified} />
      <Route component={NotFound} />
    </Switch>
  )
}

export default withRouter(BaseRoutes)